import { render, staticRenderFns } from "./RecipeSavedCollectionLinkCard.vue?vue&type=template&id=7480f814&"
import script from "./RecipeSavedCollectionLinkCard.vue?vue&type=script&lang=js&"
export * from "./RecipeSavedCollectionLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./RecipeSavedCollectionLinkCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports